window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.searchResultsList = `
    <style>
        .flex {
            display: flex;
            flex-wrap: wrap;
        }

        hawksearch-search-results-item {
            width: calc(33% - 21px);
            margin: 0 21px 20px 0;
            position: relative;
            display: block;
            background: #fff;
            border-radius: 0 0 4px 4px;
            transition: all .3s ease;
            border: .5px solid #d1d5db;
            height: stretch;
        }

        hawksearch-search-results-item:hover {
            transition: all .3s ease;
            box-shadow: 0 0 27px rgba(0, 0, 0, .15);
        }

        @media screen and (max-width: 991px), print {
            hawksearch-search-results-item {
                width: calc(50% - 11px);
                margin-right: 21px;
                margin-bottom: 16px;
            }

            hawksearch-search-results-item:nth-child(2n) {
                margin-right: 0;
            }
        }

        @media screen and (max-width: 767px), print {
            hawksearch-search-results-item {
                width: calc(50% - 8px);
                margin-right: 16px;
                margin-bottom: 16px;
            }

            hawksearch-search-results-item:nth-child(2n) {
                margin-right: 0;
            }
        }

        @media screen and (max-width: 374px), print {
            hawksearch-search-results-item {
                width: 100%;
                margin-right: 0;
            }
        }
    </style>
    <div class="flex search-results-list">
        {{#each items}}
        <hawksearch-search-results-item class="product-item"></hawksearch-search-results-item>
        {{/each}}
    </div>
`;
